import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getGalleryHeader } from '@/services/gallery'
import { getListSezRegions } from '@/services/sez-regions'
import { wrapper } from '@/store'

import Album from './Album'

const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <Album />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getGalleryHeader.initiate({ headers: { ...paramsList.headers } })),
    store.dispatch(getListSezRegions.initiate(paramsList)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'album'])),
    },
  }
})

export default Page
